enum LaborEnum {
  NULL = 0,
  FIRST_AID = 1,
  INDIVIDUAL_PROTECTION = 2,
  COMMON = 3,
  HAZARDOUS_PRODUCTION_FACTORS = 4,
  EARTHWORKS = 6,
  BUILDING_REPAIRS = 7,
  TECHNOLOGICAL_EQUIPMENT = 8,
  HIGH_ALTITUDE_WORK = 9,
  FIRE_HAZARDOUS_WORKS = 10,
  CONFINED_SPACES = 11,
  CONSTRUCTION_WORKS = 12,
  TOXIC_SUBSTANCES = 13,
  GAS_HAZARDOUS_WORKS = 14,
  FIRE_WORKS = 15,
  LIFTING_STRUCTURES = 16,
  THERMAL_POWER_PLANTS = 17,
  ELECTRICAL_INSTALLATIONS = 18,
  EXCESSIVE_PRESSURE_VESSELS = 19,
  ANIMALS = 20,
  DIVING = 21,
  EXPLOSIVE = 22,
  ROADS_AND_RAILWAYS = 23,
  PATHOGENIC_SOIL_CONTAMINATION = 24,
  DANGEROUS_CONDITIONS = 25,
  MOVING_HEAVY_LOADS = 26,
  RADIOACTIVE = 27,
  HAND_TOOL = 28,
  THEATER = 29
}

export const laborsList = [
  { value: LaborEnum.NULL, label: "Не указано" },
  { value: LaborEnum.FIRST_AID, label: "Оказание первой помощи пострадавшим" },
  {
    value: LaborEnum.INDIVIDUAL_PROTECTION,
    label: "Использование (применение) средств индивидуальной защиты"
  },
  {
    value: LaborEnum.COMMON,
    label:
      "Общие вопросы охраны труда и функционирования системы управления охраной труда"
  },
  {
    value: LaborEnum.HAZARDOUS_PRODUCTION_FACTORS,
    label:
      "Безопасные методы и приемы выполнения работ при воздействии вредных и (или) опасных производственных факторов, источников опасности, идентифицированных в рамках специальной оценки условий труда и оценки профессиональных рисков"
  },
  {
    value: LaborEnum.EARTHWORKS,
    label: "Безопасные методы и приемы выполнения земляных работ"
  },
  {
    value: LaborEnum.BUILDING_REPAIRS,
    label:
      "Безопасные методы и приемы выполнения ремонтных, монтажных и демонтажных работ зданий и сооружений"
  },
  {
    value: LaborEnum.TECHNOLOGICAL_EQUIPMENT,
    label:
      "Безопасные методы и приемы выполнения работ при размещении, монтаже, техническом обслуживании и ремонте технологического оборудования (включая технологическое оборудование)"
  },
  {
    value: LaborEnum.HIGH_ALTITUDE_WORK,
    label: "Безопасные методы и приемы выполнения работ на высоте"
  },
  {
    value: LaborEnum.FIRE_HAZARDOUS_WORKS,
    label: "Безопасные методы и приемы выполнения пожароопасных работ"
  },
  {
    value: LaborEnum.CONFINED_SPACES,
    label:
      "Безопасные методы и приемы выполнения работ в ограниченных и замкнутых пространствах (ОЗП)"
  },
  {
    value: LaborEnum.CONSTRUCTION_WORKS,
    label:
      "Безопасные методы и приемы выполнения строительных работ, в том числе: - окрасочные работы - электросварочные и газосварочные работы"
  },
  {
    value: LaborEnum.TOXIC_SUBSTANCES,
    label:
      "Безопасные методы и приемы выполнения работ, связанных с опасностью воздействия сильнодействующих и ядовитых веществ"
  },
  {
    value: LaborEnum.GAS_HAZARDOUS_WORKS,
    label: "Безопасные методы и приемы выполнения газоопасных работ"
  },
  {
    value: LaborEnum.FIRE_WORKS,
    label: "Безопасные методы и приемы выполнения огневых работ"
  },
  {
    value: LaborEnum.LIFTING_STRUCTURES,
    label:
      "Безопасные методы и приемы выполнения работ, связанные с эксплуатацией подъемных сооружений"
  },
  {
    value: LaborEnum.THERMAL_POWER_PLANTS,
    label:
      "Безопасные методы и приемы выполнения работ, связанные с эксплуатацией тепловых энергоустановок"
  },
  {
    value: LaborEnum.ELECTRICAL_INSTALLATIONS,
    label: "Безопасные методы и приемы выполнения работ в электроустановках"
  },
  {
    value: LaborEnum.EXCESSIVE_PRESSURE_VESSELS,
    label:
      "Безопасные методы и приемы выполнения работ, связанные с эксплуатацией сосудов, работающих под избыточным давлением"
  },
  {
    value: LaborEnum.ANIMALS,
    label: "Безопасные методы и приемы обращения с животными"
  },
  {
    value: LaborEnum.DIVING,
    label: "Безопасные методы и приемы при выполнении водолазных работ"
  },
  {
    value: LaborEnum.EXPLOSIVE,
    label:
      "Безопасные методы и приемы работ по поиску, идентификации, обезвреживанию и уничтожению взрывоопасных предметов"
  },
  {
    value: LaborEnum.ROADS_AND_RAILWAYS,
    label:
      "Безопасные методы и приемы работ в непосредственной близости от полотна или проезжей части эксплуатируемых автомобильных и железных дорог"
  },
  {
    value: LaborEnum.PATHOGENIC_SOIL_CONTAMINATION,
    label:
      "Безопасные методы и приемы работ, на участках с патогенным заражением почвы"
  },
  {
    value: LaborEnum.DANGEROUS_CONDITIONS,
    label:
      "Безопасные методы и приемы работ по валке леса в особо опасных условиях"
  },
  {
    value: LaborEnum.MOVING_HEAVY_LOADS,
    label:
      "Безопасные методы и приемы работ по перемещению тяжеловесных и крупногабаритных грузов при отсутствии машин соответствующей грузоподъемности и разборке покосившихся и опасных (неправильно уложенных) штабелей круглых лесоматериалов"
  },
  {
    value: LaborEnum.RADIOACTIVE,
    label:
      "Безопасные методы и приемы работ с радиоактивными веществами и источниками ионизирующих излучений"
  },
  {
    value: LaborEnum.HAND_TOOL,
    label:
      "Безопасные методы и приемы работ с ручным инструментом, в том числе с пиротехническим"
  },
  {
    value: LaborEnum.THEATER,
    label: "Безопасные методы и приемы работ в театрах"
  }
];
